module.exports = __webpack_public_path__ + "img/tai-app-415x315.1c36f35b.jpg";